import { Boundaries } from "@planzone/core";
import { projectReport } from "@planzone/dto";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { report }: Boundaries["removeProjectReport"]["request"],
): State {
  return [...state, { request: setRequestStateToPending(), report }];
}

function handleSuccess(
  state: State,
  { report }: Boundaries["removeProjectReport"]["success"],
): State {
  return state.map((res) =>
    res.report.uuid === report.uuid
      ? { ...res, request: setRequestStateToSuccess(), report }
      : res,
  );
}

function handleFailure(
  state: State,
  { report }: Boundaries["removeProjectReport"]["failure"],
): State {
  return state.map((res) =>
    res.report.uuid === report.uuid
      ? { ...res, request: setRequestStateToFailure() }
      : res,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeProjectReportRequested]: handleRequest,
    [events.removeProjectReportSucceeded]: handleSuccess,
    [events.removeProjectReportFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
